/* unplugin-vue-components disabled */import { render } from "./all-agents.vue?vue&type=template&id=308c22bb&scoped=true"
import script from "./all-agents.vue?vue&type=script&lang=js"
export * from "./all-agents.vue?vue&type=script&lang=js"

import "./all-agents.vue?vue&type=style&index=0&id=308c22bb&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308c22bb"],['__file',"src/pages/settings/superuser/all-agents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "308c22bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('308c22bb', __exports__)) {
    api.reload('308c22bb', __exports__)
  }
  
  module.hot.accept("./all-agents.vue?vue&type=template&id=308c22bb&scoped=true", () => {
    api.rerender('308c22bb', render)
  })

}


export default __exports__